export const provincesColums = [
  {
    name: "Nombre",
    selector: (row) => row["name"],
    sortable: true,
    center: true,
  },
  {
    name: "uid",
    selector: (row) => row["uuid"],
    sortable: true,
    center: false,
  },
];
